export default __webpack_public_path__ + "static/media/favorite.3cdb40e7.svg";